// extracted by mini-css-extract-plugin
export default {"border":"qj-0-","cardBackground":"Ny-JF","blackBackground":"_8c-k-","cardContainer":"IKiAU","label":"G7NSl","cardTitle":"uSAIH","cardText":"_9xKp-","skeleton-progress":"ektCQ"};